import { WorkSitesListRequest } from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';

export class WorkSiteService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async list(params: Record<string, any>, filter?: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new WorkSitesListRequest({
      token: accessToken,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }
}
